import { render, staticRenderFns } from "./CreateHarbergerFutarchyVoting.vue?vue&type=template&id=d4e86e50"
import script from "./CreateHarbergerFutarchyVoting.vue?vue&type=script&lang=js"
export * from "./CreateHarbergerFutarchyVoting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports